// Filename: uicanvasstageseq.js
// Timestamp: 2018.12.10-10:05:34 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import {
  gnnodeChildKeysGet as nodeChildKeysGet
} from '@bumblehead/gani/src/gnnode.js'

import {
  gnnodeosxGet as nodeosxGet
} from '@bumblehead/gani/src/gnnodeos.js'

import gnnodex from '@bumblehead/gani/src/gnnodex.js'
import gnnodexui from '@bumblehead/gani/src/gnnodexui.js'

const gnnode_childgetfirst = (gr, node) => (
  gr.get(nodeChildKeysGet(node)[0]))

const isinrange = (start, end, current) => (
  Boolean(start <= current && current <= end))

const onrender = (ss, cfg, gr, nd, pg, prev, stagecfg, timess_current) => {
  let nodecfg
  const {
    actionnode,
    actionnodeui,
    start,
    end
  } = prev

  if (actionnode) {
    nodecfg = gnnodex.prevget(cfg, actionnode)

    actionnodeui.setvisibility(
      ss, cfg, gr, actionnode, nodecfg,
      stagecfg, pg.isinrange(start, end, timess_current))
  }
}

const getactionnode = (ss, cfg, gr, nd) => (
  gnnode_childgetfirst(gr, nd))

const addtoscene = (ss, cfg, gr, nd, pg, stagecfg) => {
  const rafcfg = gnnodex.prevget(cfg, nd)
  const actionnode = pg.getactionnode(ss, cfg, gr, nd)

  if (actionnode) {
    rafcfg.actionnode = actionnode
    rafcfg.actionnodeui = nodeosxGet(cfg, gr, actionnode)
    // locates nodes previous subject

    const nda = actionnode
    const ndarafcfg = gnnodex.prevget(cfg, actionnode)

    rafcfg.actionnodeui.addtoscene(
      ss, cfg, gr, nda, ndarafcfg, stagecfg)
  }

  return stagecfg
}

const rebuildscene = (ss, cfg, gr, nd, pg) => {
  const actionnode = pg.getactionnode(ss, cfg, gr, nd)
  const actionui = actionnode && nodeosxGet(cfg, gr, actionnode)

  if (actionui) {
    // gani.node.nodeui(cfg, actionnode).rebuildscene(
    //   sess, cfg, graph, actionnode
    // );
  }
}

const xonsubj = (ss, cfg, gr, nd, prev, { start, end }) => {
  Object.assign(prev, {
    start: +start,
    end: +end
  })

  return true
}

export default Object.assign({}, gnnodexui, {
  type: 'uicanvasstageseq',
  xonsubj,
  isinrange,
  onrender,
  getactionnode,
  addtoscene,
  rebuildscene
})
